// Organization color palette
export const colors = {
  primary: {
    dark: '#153B55', // Dark blue
    medium: '#2B7781', // Teal
    light: '#0DAC99', // Turquoise
  },
  // Derived shades for UI elements
  ui: {
    darkBlue: '#153B55',
    teal: '#2B7781',
    turquoise: '#0DAC99',
    lightTeal: '#d0e8ea', // Light teal for backgrounds
    veryLightTeal: '#e6f1f2', // Very light teal for subtle backgrounds
    white: '#ffffff',
  },
}
